{
    "name": "sphere-portal",
    "version": "2026.1.0",
    "platformVersion": "3.3.0",
    "license": "UNLICENSED",
    "scripts": {
        "start": "nx serve sphere --proxy-config proxy.config.json",
        "start:platform": "nx serve sphere-platform-ssr --proxy-config proxy.config.json",
        "start:verbose": "nx serve sphere --proxy-config proxy.config.json --verbose",
        "start:hmr": "nx serve sphere --hmr --proxy-config proxy.config.json",
        "build": "nx build sphere",
        "build:staging": "nx build sphere --configuration=staging",
        "build:test": "nx build sphere",
        "build:prod": "nx build sphere --configuration production",
        "build:stats": "nx build sphere --configuration production --stats-json ",
        "test": "nx run-many -t test",
        "lint": "nx run-many -t lint",
        "test:chrome": "nx test sphere --browsers Chrome",
        "test:headless": "nx test sphere --browsers ChromeHeadless",
        "test:ci": "nx test sphere --browsers ChromeHeadlessNoSandbox",
        "test:sphere": "nx test sphere",
        "test:sphere:watch": "nx test sphere --watch",
        "test:sphere:coverage": "nx test sphere --coverage",
        "cypress:open": "cypress open",
        "cypress:run": "cypress run",
        "cypress:ci": "run-p --race start cypress:run",
        "open-api-gen-authorization-api": "node ./utils/replace-api-uniqueItems.js authorization-api && openapi-generator-cli generate --generator-key authorization-api",
        "open-api-gen-calendar-api": "node ./utils/replace-api-uniqueItems.js calendar-api && openapi-generator-cli generate --generator-key calendar-api",
        "open-api-gen-curve-api": "node ./utils/replace-api-uniqueItems.js curve-api && openapi-generator-cli generate --generator-key curve-api",
        "open-api-gen-curve-build-request-api": "node ./utils/replace-api-uniqueItems.js curve-build-request-api && openapi-generator-cli generate --generator-key curve-build-request-api",
        "open-api-gen-curve-definition-api": "node ./utils/replace-api-uniqueItems.js curve-definition-api && openapi-generator-cli generate --generator-key curve-definition-api",
        "open-api-gen-curve-folder-api": "node ./utils/replace-api-uniqueItems.js curve-folder-api && openapi-generator-cli generate --generator-key curve-folder-api",
        "open-api-gen-formula-api": "node ./utils/replace-api-uniqueItems.js formula-api && openapi-generator-cli generate --generator-key formula-api",
        "open-api-gen-data-management-api": "node ./utils/replace-api-uniqueItems.js data-management-api && openapi-generator-cli generate --generator-key data-management-api",
        "open-api-gen-settings-api": "node ./utils/replace-api-uniqueItems.js settings-api && openapi-generator-cli generate --generator-key settings-api",
        "open-api-gen-unit-currency-api": "node ./utils/replace-api-uniqueItems.js unit-currency-api && openapi-generator-cli generate --generator-key unit-currency-api",
        "open-api-gen-workflow-api": "node ./utils/replace-api-uniqueItems.js workflow-api && openapi-generator-cli generate --generator-key workflow-api",
        "open-api-gen-data-support-api": "node ./utils/replace-api-uniqueItems.js data-support-api && openapi-generator-cli generate --generator-key data-support-api",
        "open-api-gen-curve-support-api": "node ./utils/replace-api-uniqueItems.js curve-support-api && openapi-generator-cli generate --generator-key curve-support-api",
        "open-api-gen-notification-subscriptions-api": "node ./utils/replace-api-uniqueItems.js notification-subscriptions-api && openapi-generator-cli generate --generator-key notification-subscriptions-api",
        "open-api-gen-pricealert-api": "node ./utils/replace-api-uniqueItems.js pricealert-api && openapi-generator-cli generate --generator-key pricealert-api",
        "open-api-gen-kpler-api": "node ./utils/replace-api-uniqueItems.js kpler-api && openapi-generator-cli generate --generator-key kpler-api",
        "open-api-gen-system-metadata-api": "node ./utils/replace-api-uniqueItems.js system-metadata-api && openapi-generator-cli generate --generator-key system-metadata-api",
        "open-api-gen-adns-api": "node ./utils/replace-api-uniqueItems.js adns-api && openapi-generator-cli generate --generator-key adns-api",
        "open-api-gen-workspaces-api": "node ./utils/replace-api-uniqueItems.js workspaces-api && openapi-generator-cli generate --generator-key workspaces-api",
        "open-api-gen-news-api": "node ./utils/replace-api-uniqueItems.js news-api && openapi-generator-cli generate --generator-key news-api",
        "open-api-gen-symbol-search-api": "node ./utils/replace-api-uniqueItems.js symbol-search-api && openapi-generator-cli generate --generator-key symbol-search-api",
        "open-api-gen-sphere-ai-instant-analyst-api": "node ./utils/replace-api-uniqueItems.js sphere-ai-instant-analyst-api && openapi-generator-cli generate --generator-key sphere-ai-instant-analyst-api",
        "antlr4ts-visitor": "antlr4ts -visitor ./src/app/curve-builder/curve-designer/language/g4/Formula.g4 -o ./src/app/curve-builder/curve-designer/language/g4",
        "antlr4ts-listener": "antlr4ts ./src/app/curve-builder/curve-designer/language/g4/Formula.g4 -o ./src/app/curve-builder/curve-designer/language/g4",
        "antlr-java-visitor": "antlr4ng -Dlanguage=TypeScript -o ./src/app/curve-builder/rule-packages/rule-package-editor/monaco-drools/antlr/g4 -visitor -listener -Xexact-output-dir ./src/app/curve-builder/rule-packages/rule-package-editor/monaco-drools/antlr/g4/Java.g4",
        "antlr-java-listener": "antlr4ts -listener ./src/app/curve-builder/rule-packages/rule-package-editor/monaco-drools/antlr/g4/Java.g4 -o ./src/app/curve-builder/rule-packages/rule-package-editor/monaco-drools/antlr/g4",
        "version": "echo $npm_package_version",
        "set-env-versions": "node utils/replace.build.mjs",
        "start:sw-server": "node ./utils/sw-proxy.js && http-server -p 8080 -P http://localhost:3001? -c-1 dist/",
        "prepare": "simple-git-hooks",
        "analyze": "webpack-bundle-analyzer ./dist/stats.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "21.0.6",
        "@angular/cdk": "21.0.5",
        "@angular/common": "21.0.6",
        "@angular/compiler": "21.0.6",
        "@angular/core": "21.0.6",
        "@angular/forms": "21.0.6",
        "@angular/material": "21.0.5",
        "@angular/material-date-fns-adapter": "21.0.5",
        "@angular/material-moment-adapter": "21.0.5",
        "@angular/platform-browser": "21.0.6",
        "@angular/platform-browser-dynamic": "21.0.6",
        "@angular/platform-server": "21.0.6",
        "@angular/router": "21.0.6",
        "@angular/service-worker": "21.0.6",
        "@angular/ssr": "21.0.4",
        "@auth0/auth0-angular": "^2.3.0",
        "@date-fns/utc": "^1.2.0",
        "@genai/chatbot-ai-wc": "0.7.4",
        "@microsoft/applicationinsights-web": "^2.8.4",
        "@ng-matero/extensions": "21.1.0",
        "@ng-matero/extensions-date-fns-adapter": "21.0.0",
        "@ng-matero/extensions-moment-adapter": "21.0.0",
        "@ngrx/component": "21.0.1",
        "@ngrx/component-store": "21.0.1",
        "@ngrx/data": "21.0.1",
        "@ngrx/effects": "21.0.1",
        "@ngrx/entity": "21.0.1",
        "@ngrx/operators": "21.0.1",
        "@ngrx/router-store": "21.0.1",
        "@ngrx/signals": "21.0.1",
        "@ngrx/store": "21.0.1",
        "@ngrx/store-devtools": "21.0.1",
        "@ngx-formly/core": "^7.0.1",
        "@ngx-formly/material": "^7.0.1",
        "@ngx-pwa/local-storage": "21.0.0",
        "@openapitools/openapi-generator-cli": "~2.25.2",
        "@rudderstack/analytics-js": "^3.25.1",
        "@sbzen/ng-cron": "^18.0.0",
        "@vscode/codicons": "^0.0.36",
        "ag-grid-angular": "33.3.0",
        "ag-grid-community": "33.3.0",
        "ag-grid-enterprise": "33.3.0",
        "angular-gridster2": "21.0.0",
        "angular-resizable-element": "^7.0.2",
        "angular-split": "20.0.0",
        "antlr4ng": "^3.0.16",
        "antlr4ts-browser": "^0.5.0-alpha.4",
        "cron-parser": "^4.8.1",
        "cronstrue": "^2.59.0",
        "d3": "^7.8.5",
        "date-fns": "^3.6.0",
        "date-fns-tz": "^3.2.0",
        "duration-fns": "^3.0.1",
        "express": "^4.21.2",
        "file-saver": "^2.0.2",
        "highcharts": "12.4.0",
        "java-parser": "^2.3.4",
        "keycloak-js": "^9.0.3",
        "keyword-extractor": "^0.0.28",
        "localforage": "^1.10.0",
        "lodash": "^4.17.21",
        "marked": "^15.0.12",
        "moment": "^2.30.1",
        "moment-timezone": "^0.6.0",
        "monaco-editor": "^0.48.0",
        "nanoid": "^5.1.6",
        "ng2-pdfjs-viewer": "^19.0.0",
        "ngx-color": "^10.1.0",
        "ngx-cron-editor": "^0.8.4",
        "ngx-infinite-scroll": "20.0.0",
        "ngx-markdown": "21.0.0",
        "ngx-monaco-editor-v2": "20.3.0",
        "ngx-resize-observer": "3.2.0",
        "ngxtension": "7.0.2",
        "replace-in-file": "^8.3.0",
        "rxjs": "^7.8.2",
        "tslib": "^2.3.0",
        "uuid": "^9.0.0",
        "webfontloader": "^1.6.28",
        "zod": "^4.1.13",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "21.0.4",
        "@angular-devkit/core": "21.0.4",
        "@angular-devkit/schematics": "21.0.4",
        "@angular-eslint/eslint-plugin": "21.0.1",
        "@angular-eslint/eslint-plugin-template": "21.0.1",
        "@angular-eslint/template-parser": "21.0.1",
        "@angular/build": "21.0.4",
        "@angular/cli": "21.0.4",
        "@angular/compiler-cli": "21.0.6",
        "@angular/language-service": "21.0.6",
        "@angular/localize": "21.0.6",
        "@auth0/auth0-spa-js": "^2.9.1",
        "@babel/core": "^7.22.1",
        "@babel/preset-env": "^7.22.4",
        "@babel/runtime": "^7.26.10",
        "@cypress/webpack-preprocessor": "^5.17.1",
        "@genai/chatbot-ai": "^0.7.4",
        "@jest/globals": "30.0.5",
        "@ngx-formly/schematics": "^7.0.1",
        "@nx/angular": "22.3.3",
        "@nx/devkit": "22.3.3",
        "@nx/eslint": "22.3.3",
        "@nx/eslint-plugin": "22.3.3",
        "@nx/jest": "22.3.3",
        "@nx/js": "22.3.3",
        "@nx/web": "22.3.3",
        "@nx/workspace": "22.3.3",
        "@schematics/angular": "21.0.4",
        "@swc-node/register": "~1.9.1",
        "@swc/core": "~1.5.7",
        "@swc/helpers": "~0.5.11",
        "@types/d3": "^7.4.0",
        "@types/express": "^4.17.21",
        "@types/file-saver": "^2.0.5",
        "@types/jasmine": "~3.6.0",
        "@types/jasminewd2": "~2.0.8",
        "@types/jest": "30.0.0",
        "@types/lodash": "^4.17.21",
        "@types/luxon": "^3.4.2",
        "@types/node": "^13.7.1",
        "@types/uuid": "^9.0.1",
        "@typescript-eslint/eslint-plugin": "^7.16.0",
        "@typescript-eslint/parser": "^7.16.0",
        "@typescript-eslint/utils": "^7.16.0",
        "antlr4ng-cli": "^2.0.0",
        "antlr4ts-cli": "^0.5.0-alpha.4",
        "assert": "^2.0.0",
        "autoprefixer": "^10.4.0",
        "babel-loader": "^9.1.2",
        "cypress": "^6.6.0",
        "cypress-keycloak-commands": "^1.2.0",
        "cypress-xpath": "^1.4.0",
        "eslint": "~8.57.0",
        "eslint-config-prettier": "10.1.8",
        "highcharts-angular": "5.2.0",
        "http-proxy-middleware": ">=2.0.8",
        "http-server": "^14.1.1",
        "jasmine-core": "~3.6.0",
        "jasmine-spec-reporter": "~5.0.0",
        "jest": "30.0.5",
        "jest-environment-jsdom": "30.0.5",
        "jest-preset-angular": "15.0.0",
        "jest-util": "~30.0.0",
        "jsonc-eslint-parser": "^2.1.0",
        "karma": "~6.3.4",
        "karma-chrome-launcher": "~3.1.0",
        "karma-cli": "~2.0.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.0",
        "lint-staged": "^13.2.2",
        "luxon": "3.5.0",
        "ng-packagr": "21.0.1",
        "ngxtension-plugin": "^5.0.0",
        "npm-run-all": "^4.1.5",
        "nx": "22.3.3",
        "postcss": "^8.4.5",
        "postcss-url": "~10.1.3",
        "prettier": "^3.3.3",
        "simple-git-hooks": "^2.0.3",
        "ts-jest": "29.4.1",
        "ts-loader": "^9.4.2",
        "ts-node": "~8.6.2",
        "typescript": "5.9.3",
        "util": "^0.12.4",
        "verdaccio": "^6.0.5",
        "webpack": "^5.89.0",
        "webpack-bundle-analyzer": "^4.5.0"
    },
    "publishConfig": {
        "registry": "https://nexus.datagenic.net/repository/npm-private/"
    },
    "lint-staged": {
        "*.{ts,js,css,scss,html,json,md}": "prettier --write"
    },
    "browser": {
        "fs": false
    },
    "simple-git-hooks": {
        "pre-commit": "npx lint-staged"
    },
    "pnpm": {
        "overrides": {
            "ag-grid-enterprise@<33.3.0": ">=33.3.0",
            "ag-grid-community@<33.3.0": ">=33.3.0",
            "axios@>=1.0.0 <1.12.0": ">=1.12.0",
            "http-proxy-middleware@<2.0.7": ">=2.0.7",
            "cookie@<0.7.0": ">=0.7.0",
            "http-proxy-middleware@>=1.3.0 <2.0.9": ">=2.0.9",
            "http-proxy-middleware@>=1.3.0 <2.0.8": ">=2.0.8",
            "form-data@<2.5.4": ">=2.5.4",
            "tmp@<=0.2.3": ">=0.2.4",
            "@angular/ssr@>=20.0.0-next.0 <20.3.6": ">=20.3.6",
            "xml2js@<0.5.0": ">=0.5.0",
            "@cypress/request@<=2.88.12": ">=3.0.0",
            "tough-cookie@<4.1.3": ">=4.1.3",
            "ws@>=8.0.0 <8.17.1": ">=8.17.1",
            "micromatch@<4.0.8": ">=4.0.8",
            "glob@>=10.3.7 <=11.0.3": ">=11.1.0"
        }
    },
    "nx": {
        "includedScripts": []
    },
    "packageManager": "pnpm@10.28.2+sha512.41872f037ad22f7348e3b1debbaf7e867cfd448f2726d9cf74c08f19507c31d2c8e7a11525b983febc2df640b5438dee6023ebb1f84ed43cc2d654d2bc326264"
}
